import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo.jpg";

const Footer = () => {
  return (
    <footer className="bg-dark text-light py-5">
      <div className="container">
        {/* Main Footer Content */}
        <div className="row g-4">
          {/* Services Column */}
          <div className="col-lg-3 col-md-6">
            <h5 className="text-white mb-3 ">Our Services</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link
                  to="/services/corporate-housekeeping"
                  className="text-light text-decoration-none footer-link"
                >
                  <i className="fas fa-chevron-right  me-2"></i>
                  Corporate Housekeeping
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/services/industrial-housekeeping"
                  className="text-light text-decoration-none footer-link"
                >
                  <i className="fas fa-chevron-right  me-2"></i>
                  Industrial Housekeeping
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/services/facade-cleaning"
                  className="text-light text-decoration-none footer-link"
                >
                  <i className="fas fa-chevron-right  me-2"></i>
                  Facade Cleaning
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/services/project-cleaning"
                  className="text-light text-decoration-none footer-link"
                >
                  <i className="fas fa-chevron-right  me-2"></i>
                  Project Cleaning
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/services/staffing-services"
                  className="text-light text-decoration-none footer-link"
                >
                  <i className="fas fa-chevron-right  me-2"></i>
                  Staffing Services
                </Link>
              </li>
            </ul>
          </div>

          {/* Useful Links Column */}
          <div className="col-lg-3 col-md-6">
            <h5 className="text-white mb-3 ">Useful Links</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link
                  to="/about"
                  className="text-light text-decoration-none footer-link"
                >
                  <i className="fas fa-chevron-right  me-2"></i>
                  About Us
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/clients"
                  className="text-light text-decoration-none footer-link"
                >
                  <i className="fas fa-chevron-right  me-2"></i>
                  Our Clients
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/blog"
                  className="text-light text-decoration-none footer-link"
                >
                  <i className="fas fa-chevron-right  me-2"></i>
                  Blog & Insights
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/contact"
                  className="text-light text-decoration-none footer-link"
                >
                  <i className="fas fa-chevron-right  me-2"></i>
                  Careers
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/contact"
                  className="text-light text-decoration-none footer-link"
                >
                  <i className="fas fa-chevron-right  me-2"></i>
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Policies Column */}
          {/* <div className="col-lg-2 col-md-6">
            <h5 className="text-white mb-3 ">Policies</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link
                  to="/contact"
                  className="text-light text-decoration-none footer-link"
                >
                  <i className="fas fa-chevron-right  me-2"></i>
                  Privacy Policy
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/contact"
                  className="text-light text-decoration-none footer-link"
                >
                  <i className="fas fa-chevron-right  me-2"></i>
                  Refund Policy
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/contact"
                  className="text-light text-decoration-none footer-link"
                >
                  <i className="fas fa-chevron-right  me-2"></i>
                  Safety Policy
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/contact"
                  className="text-light text-decoration-none footer-link"
                >
                  <i className="fas fa-chevron-right  me-2"></i>
                  Code of Conduct
                </Link>
              </li>
            </ul>
          </div> */}

          <div className="col-lg-2 col-md-6"></div>

          {/* Contact Column */}
          <div className="col-lg-4 col-md-5">
            <div className="contact-item">
              {/* Address */}
              <div className="mb-4">
                <div className="d-flex align-items-start">
                  <div className="contact-icon-wrapper me-3">
                    <i className="fas fa-map-marker-alt"></i>
                  </div>
                  <div>
                    <span className="text-light">
                      Office No. 1, Priyadarshani Nagar Society, Sinhgad Road,
                      Pune - 411030
                    </span>
                  </div>
                </div>
              </div>

              {/* Phone */}
              <div className="mb-4">
                <div className="d-flex align-items-start">
                  <div className="contact-icon-wrapper me-3">
                    <i className="fas fa-phone"></i>
                  </div>
                  <div>
                    <h6 className="contact-label mb-1">Call Us</h6>
                    <div>
                      <a
                        href="tel:+919822738807"
                        className="text-light text-decoration-none d-block contact-link"
                      >
                        +91 9822738807 / +91 8007138807
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              {/* Email */}
              <div>
                <div className="d-flex align-items-start">
                  <div className="contact-icon-wrapper me-3">
                    <i className="fas fa-envelope"></i>
                  </div>
                  <div>
                    <h6 className="contact-label mb-1">Email Us</h6>
                    <a
                      href="mailto:rrfms1@gmail.com"
                      className="text-light text-decoration-none contact-link"
                    >
                      rrfms1@gmail.com
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Logo Section */}
        <div className="text-center">
          <div className="d-flex align-items-center justify-content-center">
            <div
              className="flex-grow-1 border-top border-secondary"
              style={{ maxWidth: "100%" }}
            ></div>
            <img
              src={logo}
              alt="RR Facility Management Services"
              className="mx-3 rounded-circle img-fluid"
              style={{ maxHeight: "100px", width: "auto", objectFit: "cover" }}
            />
            <div
              className="flex-grow-1 border-top border-secondary"
              style={{ maxWidth: "100%" }}
            ></div>
          </div>
        </div>

        {/* Social Media */}
        <div className="row">
          <div className="col-md-6">
            <div className="d-flex mb-4 mb-md-0 gap-3">
              <Link
                to="/facebook"
                className="social-icon text-light d-flex align-items-center justify-content-center"
                aria-label="Facebook"
              >
                <i className="fab fa-facebook-f"></i>
              </Link>
              <Link
                to="/linkedin"
                className="social-icon text-light d-flex align-items-center justify-content-center"
                aria-label="LinkedIn"
              >
                <i className="fab fa-linkedin-in"></i>
              </Link>
              <Link
                to="/twitter"
                className="social-icon text-light d-flex align-items-center justify-content-center"
                aria-label="Twitter"
              >
                <i className="fab fa-twitter"></i>
              </Link>
              <Link
                to="/instagram"
                className="social-icon text-light d-flex align-items-center justify-content-center"
                aria-label="Instagram"
              >
                <i className="fab fa-instagram"></i>
              </Link>
            </div>
          </div>

          <div className="col-md-6 text-md-end">
            <p className="text-light">
              &copy; {new Date().getFullYear()} R R Facility Management
              Services.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
